<template>
  <div class="tabs">
    <el-tag
      v-for="(item, index) in tags"
      :key="item.path"
      :closable="item.name !== 'home'"
      :effect="$route.name === item.name ? 'dark' : 'plain'"
      @click="changeMenu(item)"
      @close="handleClose(item, index)"
      size="small"
    >
      {{ item.label }}
    </el-tag>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "CommonTag",
  data() {
    return {};
  },
  mounted() {
    console.log(this.$route.name, "wwwwww");
  },
  computed: {
    ...mapState({
      tags: (state) => state.tab.tabsList,
    }),
  },
  methods: {
    //tag跳转
    changeMenu(item) {
      console.log(this);
      if(this.$route.path!==item.path){
        this.$router.push({ name: item.name });
      }
      
    },
    // tag删除
    ...mapMutations(["closeTag"]),
    handleClose(item,index) {
      //调用store中的mutation
      this.closeTag(item);
      const length = this.tags.length;
      // 删除之后的跳转逻辑
      if (item.name !== this.$route.name) {
        return;
      }
      // 表示的是删除的最后一项
      if (index === length) {
        this.$router.push({
          name: this.tags[index - 1].name,
        });
      } else {
        this.$router.push({
          name: this.tags[index].name,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tabs{
    padding:20px;
    padding-bottom: 10px;
    .el-tag{
        margin-right: 15px;
        cursor:pointer;
    }
}

</style>